export default{
  label:'vertical-align',
  valueScope:[
    'align-baseline',
    'align-top',
    'align-middle',
    'align-bottom',
    'align-text-top',
    'align-text-bottom',
  ],
}


// WEBPACK FOOTER //
// ./src/shell/schemas/general/text/vertical-align.js